import { ComponentProps, useRef } from "react";
import { getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";

const PERFORMANCE_BUTTON_PATH = "/performance-button";

const usePerformanceButtonAdapter = (): ComponentProps<typeof IFrame> => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig("coaching", "coaching");
  const origin = new URL(config.iFrameUrl).origin;
  const basePath = `${origin}${PERFORMANCE_BUTTON_PATH}`;
  const src = basePath;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(ref, "Performance", PERFORMANCE_BUTTON_PATH);
  return {
    ref,
    basePath,
    src: staticSrc,
    title: "Performance",
  };
};

export { usePerformanceButtonAdapter };
